<template>
  <div class="bb-country-flag">
    <img class="bb-country-flag__image"
         :src="flag"
         ref="bbCountryFlag"
         @mouseleave="displayCountryName = false"
         @mouseenter="displayCountryName = true">
    <transition name="bounce">
      <div class="bb-country-flag__name"
           v-if="!hidePopup && displayCountryName && country.name">
        {{country.name}}
      </div>
    </transition>
  </div>
</template>

<script>
import countriesList from '@/constants/countriesList'
import defaultFlag from '@/assets/images/countriesFlags/Unknown.png'
import {find, get} from 'lodash'

export default {
  name: 'CountryFlag',
  props: ['countryId', 'hidePopup'],
  data () {
    return {
      flag: defaultFlag,
      displayCountryName: false,
      country: {},
      countriesList: countriesList
    }
  },
  computed: {
    countryFlag: {
      get () {
        return this.$store.getters.countryFlags
      },
      set (data) {
        this.$store.dispatch('setCountryFlags', data)
      }
    }
  },
  methods: {
    async setCountryById (id) {
      this.country = find(this.countriesList, {id: id}) || {}
      const flag = get(this.country, 'file', '')
      this.flag = flag || await this.importFlag(this.country)
    },
    async importFlag ({fileName, id, file}) {
      const county = find(this.countryFlag, {id: id})
      const fileFlag = get(county, 'file', '')
      if (fileFlag) return fileFlag
      try {
        const file = await import('@/assets/images/countriesFlags/' + fileName)
        this.countryFlag.push({id, file})
        return file
      } catch (e) {
        console.error(e)
        return defaultFlag
      }
    }
  },
  beforeMount () {
    this.setCountryById(this.countryId)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-country-flag {
    @include global-font;
    position: relative;

    &__image {
      width: 22px;
      height: auto;
      cursor: pointer;
    }

    &__name {
      position: absolute;
      left: 0;
      top: 27px;
      padding: 6px 12px;
      background: rgba($color-black, 0.53);
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      border-radius: 5px;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      color: $color-white;
      white-space: nowrap;
      z-index: 3;
      pointer-events: none;

      &:after{
        content: '';
        position: absolute;
        left: 7px;
        bottom: 100%;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 5px solid rgba($color-black, 0.53);
        box-shadow: 0 0 12px rgba($color-black, 0.12);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/CountryFlag/CountryFlag.vue